import Vue from 'vue';
import App from '@/entries/study/App.vue';

import '@/entries/user';
import router from '@/entries/study/router';
import { PublicRoutes } from '@/entries/study/router/AppRouteConfig';
import ErrorHandler from '@/classes/common/ErrorHandler';



new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

// エラーハンドリング設定
ErrorHandler.initialize(router, String(PublicRoutes.Unauthorized.alias), String(PublicRoutes.Exception.alias));
